import { useAuthenticatedSWR } from '../api';
import { MX_PLAN_TYPES_BASE_URL } from './constants';
import { getPetDetailParams } from './functions';

export const useMxPlanTypes = ({ subscriptionId, petDetails = undefined }) => {
  const params = petDetails ? getPetDetailParams(petDetails) : '';
  const { data, error, isValidating, mutate } = useAuthenticatedSWR(
    subscriptionId
      ? `${MX_PLAN_TYPES_BASE_URL}${subscriptionId}/plans/${
          petDetails ? `?${params.toString()}` : ''
        }`
      : null,
  );

  return {
    isLoading: subscriptionId ? !data && !error : false,
    data,
    error,
    isValidating,
    mutate,
  };
};
